import { useIntl, FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Heading from 'components/v2/Heading'
import { typeMessages } from 'features/Inventories/components/Type/messages'
import { safeFormatMessage } from 'utils/intl'

const Container = styled.div<TSFixMe>`
  padding: 30px 20px;
`

export const InventoryHeader = ({ inventory = {} }): TSFixMe => {
  const intl = useIntl()

  return (
    <Container>
      <Heading.H3>
        <FormattedMessage
          id="spanish.inventoryItems.header.label"
          defaultMessage="{inventoryType} {inventoryName}"
          values={{
            // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
            inventoryName: inventory.name,
            // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
            inventoryType: safeFormatMessage({ intl, messages: typeMessages, key: inventory.type })
          }}
        />
      </Heading.H3>
    </Container>
  )
}
